import { useEffect, useState } from "react";

export const useEmbedApp = () => {
  const [isShopifyEmbed, setIsShopifyEmbed] = useState(false);

  useEffect(() => {
    const checkShopifyEmbed = () => {
      const isEmbed =
        typeof window.shopify !== "undefined" ||
        typeof window.shopify !== "undefined";
      setIsShopifyEmbed(isEmbed);
    };

    checkShopifyEmbed();
  }, []);

  return isShopifyEmbed;
};
